export default {
  // 通用词汇
  common: {
    welcome: "欢迎使用 WYNI AI ERP",
    
    // 动作
    add: "新增",
    edit: "编辑",
    delete: "删除",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    submit: "提交",
    search: "搜索",
    filter: "筛选",
    export: "导出",
    import: "导入",
    print: "打印",
    refresh: "刷新",
    reset: "重置",
    clear: "清除",
    close: "关闭",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    finish: "完成",
    view: "查看",
    update: "更新",
    create: "创建",
    
    // 状态
    active: "启用",
    inactive: "停用",
    enabled: "已启用",
    disabled: "已停用",
    pending: "待处理",
    approved: "已批准",
    rejected: "已拒绝",
    completed: "已完成",
    cancelled: "已取消",
    loading: "加载中...",
    success: "成功",
    error: "错误",
    warning: "警告",
    info: "信息",
    
    // 基础词汇
    name: "名称",
    description: "描述",
    status: "状态",
    type: "类型",
    category: "类别",
    date: "日期",
    time: "时间",
    amount: "金额",
    quantity: "数量",
    price: "价格",
    total: "总计",
    subtotal: "小计",
    tax: "税费",
    discount: "折扣",
    code: "编号",
    id: "ID",
    email: "电子邮件",
    phone: "电话",
    address: "地址",
    notes: "备注",
    remarks: "说明",
    noData: "暂无数据",
    revenue: "营业额",
  },

  // 认证相关
  auth: {
    login: "登录",
    logout: "登出",
    email: "电子邮件",
    password: "密码",
    username: "用户名",
    loginSuccess: "登录成功",
    loginFailed: "登录失败",
    login_success: "登录成功",
    login_failed: "登录失败",
    logout_success: "登出成功",
    forgotPassword: "忘记密码",
    resetPassword: "重置密码",
    changePassword: "修改密码",
  },

  // 导航菜单
  navigation: {
    dashboard: "仪表板",
    userManagement: "用户管理",
    users: "用户管理",
    accounting: "会计财务",
    sales: "销售管理",
    procurement: "采购管理",
    inventory: "库存管理",
    manufacturing: "生产管理",
    hr: "人力资源",
    crm: "客户关系管理",
    reports: "报表中心",
    settings: "系统设置",
    products: "产品管理",
    orders: "订单管理",
    warehouse: "仓库管理",
    projects: "项目管理",
  },

  // 仪表板
  dashboard: {
    overview: "概览",
    statistics: "统计数据",
    recentActivity: "最近活动",
    quickActions: "快捷操作",
    keyMetrics: "关键指标",
    performance: "绩效表现",
    alerts: "提醒",
    notifications: "通知",
  },

  // 销售管理
  sales: {
    overview: "销售概览",
    orders: "销售订单",
    quotations: "报价单",
    invoices: "发票",
    customers: "客户",
    products: "产品",
    analytics: "销售分析",
    pipeline: "销售漏斗",
    forecast: "销售预测",
    commission: "佣金",
    targets: "销售目标",
    performance: "销售绩效",
  },

  // 客户关系管理
  crm: {
    overview: "CRM概览",
    contacts: "联系人",
    leads: "潜在客户",
    opportunities: "商机",
    activities: "活动",
    campaigns: "营销活动",
    pipeline: "销售管道",
    reports: "CRM报表",
    settings: "CRM设置",
  },

  // 库存管理
  inventory: {
    overview: "库存概览",
    products: "产品",
    warehouses: "仓库",
    stockLevels: "库存水平",
    movements: "库存变动",
    adjustments: "库存调整",
    transfers: "库存转移",
    reports: "库存报表",
    alerts: "库存警报",
    optimization: "库存优化",
    valuation: "库存估值",
    tracking: "库存跟踪",
  },

  // 采购管理
  procurement: {
    overview: "采购概览",
    requisitions: "采购申请",
    orders: "采购订单",
    vendors: "供应商",
    receipts: "收货单",
    invoices: "供应商发票",
    contracts: "采购合同",
    analytics: "采购分析",
    approval: "采购审批",
    workflow: "采购流程",
  },

  // 人力资源
  hr: {
    overview: "人力资源概览",
    employees: "员工管理",
    attendance: "考勤管理",
    leave: "请假管理",
    payroll: "薪资管理",
    performance: "绩效管理",
    recruitment: "招聘管理",
    training: "培训管理",
    benefits: "福利管理",
    reports: "人力资源报表",
    analytics: "人力资源分析",
  },

  // 生产管理
  manufacturing: {
    overview: "生产概览",
    workOrders: "工作订单",
    bom: "物料清单",
    routing: "工艺路线",
    capacity: "产能规划",
    scheduling: "生产排程",
    quality: "质量管理",
    maintenance: "设备维护",
    reports: "生产报表",
    analytics: "生产分析",
  },

  // 会计财务
  accounting: {
    overview: "财务概览",
    chartOfAccounts: "会计科目",
    journalEntries: "会计分录",
    generalLedger: "总账",
    trialBalance: "试算平衡表",
    incomeStatement: "损益表",
    balanceSheet: "资产负债表",
    cashFlow: "现金流量表",
    budgets: "预算管理",
    reports: "财务报表",
    analytics: "财务分析",
    reconciliation: "银行对账",
    taxation: "税务管理",
  },

  // 项目管理
  projects: {
    overview: "项目概览",
    tasks: "任务管理",
    milestones: "里程碑",
    resources: "资源管理",
    timeline: "项目时间线",
    budget: "项目预算",
    reports: "项目报表",
    collaboration: "团队协作",
    documents: "项目文档",
  },

  // 报表中心
  reports: {
    overview: "报表概览",
    financial: "财务报表",
    sales: "销售报表",
    inventory: "库存报表",
    hr: "人力资源报表",
    custom: "自定义报表",
    scheduled: "定时报表",
    analytics: "数据分析",
    dashboard: "报表仪表板",
  },

  // 系统设置
  settings: {
    overview: "设置概览",
    general: "常规设置",
    users: "用户设置",
    roles: "角色权限",
    company: "公司信息",
    preferences: "个人偏好",
    notifications: "通知设置",
    integrations: "集成设置",
    security: "安全设置",
    backup: "备份设置",
    advanced: "高级设置",
    audit: "审计日志",
  },

  // 表单标签
  form: {
    required: "必填项",
    optional: "可选项",
    pleaseSelect: "请选择",
    pleaseEnter: "请输入",
    selectAll: "全选",
    deselectAll: "取消全选",
    uploadFile: "上传文件",
    downloadFile: "下载文件",
    previewFile: "预览文件",
  },

  // 消息提示
  messages: {
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    updateSuccess: "更新成功",
    updateFailed: "更新失败",
    createSuccess: "创建成功",
    createFailed: "创建失败",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    confirmDelete: "确认删除此项目？",
    confirmAction: "确认执行此操作？",
    noPermission: "无权限执行此操作",
    networkError: "网络错误，请稍后重试",
    systemError: "系统错误，请联系管理员",
  },

  // 时间相关
  time: {
    today: "今天",
    yesterday: "昨天",
    tomorrow: "明天",
    thisWeek: "本周",
    lastWeek: "上周",
    thisMonth: "本月",
    lastMonth: "上月",
    thisYear: "今年",
    lastYear: "去年",
    custom: "自定义",
    from: "从",
    to: "到",
    startDate: "开始日期",
    endDate: "结束日期",
  },

  // 数据表格
  table: {
    serialNumber: "序号",
    operation: "操作",
    noData: "暂无数据",
    total: "共 {{count}} 条",
    selected: "已选择 {{count}} 项",
    itemsPerPage: "每页显示",
    page: "页",
    of: "共",
    first: "首页",
    last: "末页",
    previous: "上一页",
    next: "下一页",
  },

  // 员工相关
  employee: {
    id: "员工编号",
    name: "姓名",
    firstName: "名",
    lastName: "姓",
    department: "部门",
    position: "职位",
    email: "邮箱",
    phone: "电话",
    hireDate: "入职日期",
    salary: "薪资",
    manager: "上级主管",
    status: "状态",
  },

  // 请假相关
  leave: {
    type: "请假类型",
    vacation: "年假",
    sick: "病假",
    personal: "事假",
    maternity: "产假",
    paternity: "陪产假",
    bereavement: "丧假",
    startDate: "开始日期",
    endDate: "结束日期",
    reason: "请假原因",
    status: "状态",
    balance: "假期余额",
    history: "请假历史",
  },

  // 薪资相关
  payroll: {
    period: "薪资期间",
    baseSalary: "基本工资",
    overtime: "加班费",
    bonus: "奖金",
    deduction: "扣除",
    grossPay: "应发工资",
    netPay: "实发工资",
    tax: "个人所得税",
    socialInsurance: "社会保险",
    status: "状态",
  },
};
